/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a coding sequence to tabulate how often each codon is used — total counts, frequency per 1000 codons, and the fraction each codon makes up among the synonymous codons for its amino acid. The sequence is read in frame 1; U is treated as T.`)
};

const es_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia codificante para tabular la frecuencia de uso de cada codón — conteos totales, frecuencia por 1000 codones y la fracción que representa cada codón entre los codones sinónimos de su aminoácido. La secuencia se lee en el marco 1; la U se trata como T.`)
};

const de_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine Kodierungssequenz ein, um zu tabellieren, wie oft jedes Codon verwendet wird — Gesamtanzahl, Häufigkeit pro 1000 Codons und der Anteil, den jedes Codon unter den synonymen Codons für seine Aminosäure ausmacht. Die Sequenz wird in Raster 1 gelesen; U wird als T behandelt.`)
};

const nl_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een coderende sequentie om te berekenen hoe vaak elk codon wordt gebruikt — totale aantallen, frequentie per 1000 codons, en de fractie die elk codon vormt tussen de synonieme codons voor zijn aminozuur. De sequentie wordt gelezen in frame 1; U wordt behandeld als T.`)
};

const fr_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence codante pour tabuler la fréquence d'utilisation de chaque codon — décomptes totaux, fréquence pour 1000 codons, et la fraction que chaque codon représente parmi les codons synonymes de son acide aminé. La séquence est lue dans le cadre 1 ; U est traité comme T.`)
};

const it_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza codificante per tabulare quanto spesso viene usato ciascun codone — conteggi totali, frequenza per 1000 codoni, e la frazione che ciascun codone rappresenta tra i codoni sinonimi del suo amminoacido. La sequenza viene letta nella fase 1; U viene trattata come T.`)
};

const pt_br2_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante para tabular com que frequência cada códon é usado — contagens totais, frequência por 1000 códons e a fração que cada códon representa entre os códons sinônimos de seu aminoácido. A sequência é lida no quadro 1; U é tratado como T.`)
};

const pt_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante para tabular a frequência de uso de cada codão — contagens totais, frequência por 1000 codões, e a fração que cada codão representa entre os codões sinónimos do seu aminoácido. A sequência é lida na grelha 1; U é tratado como T.`)
};

const ja_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード配列を貼り付けると、各コドンの使用頻度を表にまとめます — 総カウント数、1000コドンあたりの頻度、そのアミノ酸の同義コドンの中でそのコドンが占める割合です。配列は読み枠1で読み取られ、UはTとして扱われます。`)
};

const zh_codon_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴编码序列以统计每个密码子的使用频率——总计数、每千个密码子的频率，以及每个密码子在其氨基酸同义密码子中所占的比例。序列按阅读框 1 读取；U 按 T 处理。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_intro", locale)
	if (locale === "en") return en_codon_intro(inputs)
	if (locale === "es") return es_codon_intro(inputs)
	if (locale === "de") return de_codon_intro(inputs)
	if (locale === "nl") return nl_codon_intro(inputs)
	if (locale === "fr") return fr_codon_intro(inputs)
	if (locale === "it") return it_codon_intro(inputs)
	if (locale === "pt-BR") return pt_br2_codon_intro(inputs)
	if (locale === "pt") return pt_codon_intro(inputs)
	if (locale === "ja") return ja_codon_intro(inputs)
	return zh_codon_intro(inputs)
};